module.exports = __webpack_public_path__ + "img/54600.914464a1.jpg";